import Store from './base';


export default class StreakStatStore extends Store {
  constructor() {
    super('streak-stats');
    this.state = {
      streakStats: [],
    };
  }

  get(): Record<any, any> {
    return this.state.streakStats;
  }
}
